import type { ReactNode } from 'react';

export const symbol_g_mobiledata_badge: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-60h600v-600H180v600Zm0-600v600-600Zm200 500h201q25 0 42-17.63 17-17.62 17-42.37v-142q0-12.75-8.62-21.38Q622.75-512 610-512h-67q-12.75 0-21.37 8.68-8.63 8.67-8.63 21.5 0 12.82 8.63 21.32 8.62 8.5 21.37 8.5h38v112H380v-280h260q-3-24-19.45-42T581-680H380q-24.75 0-42.37 17.62Q320-644.75 320-620v280q0 24.75 17.63 42.37Q355.25-280 380-280Z"
		/>
	</svg>
);
